import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { ZefError } from '@vshosting/core';
import { SatPopoverComponent } from '@ncstate/sat-popover';

@Component({
    selector: 'vshcdn-pop-error',
    templateUrl: './pop-error.feature.html',
    styleUrls: ['./pop-error.feature.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule
]
})
export class PopErrorFeature {
  @Input()
  data!: ZefError[];

  @Input()
  instance!: SatPopoverComponent;

  trackBy(index: number) {
    return index;
  }
}
